import { type AppLanguage, Experience } from 'src/types';

import { getLanguagePrefixedPath } from './getLanguage';

export const validateReturnUri = (
  returnUrl: string,
  language: AppLanguage,
  experience: Experience,
  originWhitelist: string[] = [],
): string => {
  if (experience === Experience.Candidate && /^https?:\/\//.test(returnUrl)) {
    // When returnUrl is having same origin as of the current window.location origin
    if (returnUrl.indexOf(window.location.origin) === 0) {
      return validateReturnPath(
        returnUrl.substring(window.location.origin.length),
      );
    }
    // if returnUrl matches with any of the white listed urls
    const originWhitelistLen = originWhitelist.length;
    for (let ind = 0; ind < originWhitelistLen; ind++) {
      if (returnUrl.startsWith(originWhitelist[ind])) {
        return returnUrl;
      }
    }
    // If returnUrl does not match with current window.location origin or any of the white listed urls
    return getLanguagePrefixedPath(language, '/');
  }

  return validateReturnPath(returnUrl);
};

export const validateReturnPath = (returnPath: string) =>
  Boolean(returnPath.indexOf('/')) ? `/${returnPath}` : returnPath;
